<template>
  <div class="font-bold text-2xl md:text-3xl">
    <slot name="title" />
  </div>

  <div class="text-gray-600">
    <slot name="subtext" />
  </div>

  <div class="border-t-2 border-gray-300" />
</template>
